module.exports = __webpack_public_path__ + "static/media/CI.36308043.png";